// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1ADe3","footer":"ModalUpdate_footer__ucEOY"};